<template>
  <div class="rs-button-list">
    <RsButton
      v-for="(button, index) in buttons"
      :key="index"
      variant="light"
      :icon="button.icon"
      :active="activeLink === button.href"
      nav-link
      weight="far"
      @click="$emit('click', button)"
    >
      {{ button.title }}
    </RsButton>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { IRsButtonListButtonConfig } from '@/shared/interfaces/rs-button-list-button-config';

export default defineComponent({
  name: 'RsButtonList',

  props: {
    buttons: {
      type: Array as PropType<IRsButtonListButtonConfig[]>,
      default: () => [],
    },
    activeLink: {
      type: String,
      default: () => null,
    },
    vertical: {
      type: Boolean,
      default: () => false,
    },
  },
});
</script>
<style lang="scss">
@import '@/styles/_variables.scss';
.rs-button-list {
    .rs-button {
        margin-top: 10px;
        width: 100%;
        min-height: 40px;
        height: auto;
        justify-content: start;
        text-align: left;
        color: $secondary-color-dark;
        &:hover{
            background-color: transparent;
            border-color: transparent;
            color: $secondary-color;
        }
        &--active,
        &--active:hover{
            color: $white;
            background: $secondary-color;
        }
    }
}
</style>
